export default __webpack_public_path__ + "static/media/arrow-forward.61f88ebc.svg";